import {
  ALL_AUTH_METHODS,
  AUTH_TYPES,
  FACEBOOK_APP_ID,
} from '../../../constants';
import React, { Component } from 'react';
import {
  getAcmCookie,
  getAcmEmail,
  getUrlParams,
  isValidEmail,
  isValidUrl,
  storeEnrollmentLocalStorage,
} from '../../../utils';

import { AuthFormContainer } from '../../../components/authFormContainer';
import ErrorMessage from '../../../components/ErrorMessage';
import LoginForm from './loginForm';
import PropTypes from 'prop-types';
import Schemas from '../../../components/formSchemas';
import ThirdPartyLogin from './thirdPartyLogin';
import _ from 'lodash';
import { actions } from '../../../actions';
import axios from 'axios';
import { connect } from 'react-redux';

export const handleEducationCallback = (payload = {}) => {
  const { enrollment_identifier } = payload;
  const url_params = getUrlParams(window.location.search);
  if (
    enrollment_identifier !== '' &&
    !_.has(payload, 'user_identifier') &&
    isValidUrl(url_params.education_callback_url)
  ) {
    axios.post(url_params.education_callback_url, {
      enrollment_identifier,
      ref_code: url_params.ref_code,
      ref_id: url_params.ref_id,
      s_slug: url_params.s_slug,
    });
  }
};

export class LogIn extends Component {
  constructor(props) {
    super(props);
    const { email, auth_methods } = props.participant;

    const authMethods = _.isEmpty(auth_methods)
      ? ALL_AUTH_METHODS
      : auth_methods;

    this.state = {
      isLoading: false,
      promptForLogin: props.promptForLogin,
      authMethods,
      email: email,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    // if Achievement cookie is provided but email not provided
    // fall back to regular log in
    let portalEmail = getAcmEmail();
    if (!isValidEmail(portalEmail)) portalEmail = undefined;

    // currently need both email and acm cookie to work
    // read from cookie once and handle it in redux
    let hasAcmCookie = !!getAcmCookie();
    if (hasAcmCookie && !portalEmail) hasAcmCookie = false;

    this.props.updateAcmInfo({ portalEmail, hasAcmCookie });
    this.setState({ email: portalEmail });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  submit = data => {
    this.setState({ isLoading: true });

    if (this.state.promptForLogin) {
      this.props
        .loginUser(data)
        .then(this.callback)
        .catch(error => console.error(error));
    } else {
      this.props
        .createUser(data)
        .then(this.callback)
        .catch(error => console.error(error));
    }
  };

  callback = ({ payload }) => {
    storeEnrollmentLocalStorage(payload);
    handleEducationCallback(payload);
    // to avoid setting state on unmounted component when user hit login,
    // the login response has not returned but user is navigated to next page
    if (!this._isMounted) return;

    this.props.updateAcmInfo({
      portalEmail: undefined,
      hasAcmCookie: false,
    });

    this.setState({ isLoading: false });
    const hasUserIdentifier = _.has(this.props.participant, `user_identifier`);
    const authMethods = !_.isEmpty(this.props.participant['auth_methods'])
      ? this.props.participant['auth_methods']
      : ALL_AUTH_METHODS;
    if (hasUserIdentifier) {
      this.setState({
        promptForLogin: true,
        authMethods: authMethods,
      });
    }
  };

  watchForEmailChange = ({ email }) => {
    this.props.clearErrors();

    if (!this.state.promptForLogin) {
      this.setState({ email });
    } else if (!this.props.promptForLogin && email !== this.state.email) {
      // this.props.promptForLogin: if Billboard prompted user for login originally
      // if changing email when entering password, then clear the email
      this.setState({ promptForLogin: false, email: `` }, () => {
        document.getElementById('t-email').focus();
      });
    }
  };

  render() {
    const { email, promptForLogin, authMethods } = this.state;
    const {
      hero_button = 'Check Eligibility',
      participant: { hasAcmCookie = false } = {},
      hero,
      id,
    } = this.props;

    const hasBasicAuth = _.includes(authMethods, AUTH_TYPES.basic);
    const hasFbAuth = _.includes(authMethods, AUTH_TYPES.facebook);
    const message = hasFbAuth && authMethods.length === 1 ? '' : 'or';

    const config = {
      displayPasswordLink: promptForLogin,
      hero_button: promptForLogin ? 'Log In' : hero_button,
      isLoading: this.state.isLoading,
      hasAcmCookie,
    };

    return (
      <AuthFormContainer>
        <ErrorMessage errors={this.props.errors} />

        {!promptForLogin && (
          <LoginForm
            form={id + '_enroll'}
            schema={Schemas.formEnroll(hasAcmCookie)}
            submit={this.submit}
            onChange={this.watchForEmailChange}
            initialValues={{ email }}
            config={config}
            hero={hero}
          />
        )}
        {promptForLogin && (
          <React.Fragment>
            {hasBasicAuth && (
              <LoginForm
                form={id + '_basic_auth'}
                schema={Schemas.formLogin()}
                submit={this.submit}
                onChange={this.watchForEmailChange}
                initialValues={{ email }}
                config={config}
                hero={hero}
              />
            )}
            {hasFbAuth && (
              <ThirdPartyLogin
                facebookAppId={FACEBOOK_APP_ID}
                email={email}
                submit={this.submit}
                message={message}
              />
            )}
          </React.Fragment>
        )}
      </AuthFormContainer>
    );
  }
}

LogIn.defaultProps = {
  error: ``,
  promptForLogin: false,
  hasFacebookLogin: false,
  id: `login`,
};

LogIn.propTypes = {
  error: PropTypes.string,
  promptForLogin: PropTypes.bool,
};

export default connect(
  ({ participant, errors }) => ({ participant, errors }),
  dispatch => ({
    loginUser: user => dispatch(actions.loginUser(user)),
    createUser: user => dispatch(actions.createUser(user)),
    clearErrors: () => dispatch(actions.clearErrors()),
    updateAcmInfo: payload => dispatch(actions.updateAcmInfo(payload)),
  }),
)(LogIn);



// WEBPACK FOOTER //
// ./src/routes/education/components/logIn.js